import type { IStageToolbarItemRenderArgs } from '../../types';
import { PanelHierarchyItem } from './panel';
import { PopoverHierarchyItem } from './popover';

export const hierarchyItemRender = (args: IStageToolbarItemRenderArgs) => {
    const { config, toolbar } = args;
    const itemConfig = config.items.hierarchy;
    if (!itemConfig) return null;
    const available = toolbar.getItemAvailability('hierarchy');

    if (itemConfig.mode === 'popover') {
        return (
            <PopoverHierarchyItem
                {...args}
                available={available}
                hideWhenAgentLayoutEnabled={itemConfig.hideWhenAgentLayoutEnabled}
            />
        );
    }

    if (!available) return null;
    return <PanelHierarchyItem {...args} />;
};
